import { FACPG2Rutas, GetHeaderRequest, GetResponseBody } from './RutasConfig';

export const ReversalFACRequest = async (pToken, pTransaction) => {
    const result = await fetch(FACPG2Rutas.Reversal, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(pTransaction)
    });
    return await GetResponseBody(result);
};
